<template>
    <div id="app_layout" :class="{'home_bj':$route.path=='/index'}">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
        <div class="nav_bar">
            <router-link v-for="nav in navList" class="nav_item" :to="nav.path" :key="nav.path">
                <img class="nav_icon" :src="nav.icon" alt="">
                <img class="nav_active_icon" :src="nav.active_icon" alt="">
                <div class="nav_name">{{ nav.name }}</div>
            </router-link>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                navList:[
                    {name:"首页",path:"/index",icon:require("./img/tabbar/tab_home.png"),active_icon:require("./img/tabbar/tab_home_active.png")},
                    {name:"课件",path:"/courseware",icon:require("./img/tabbar/tab_courseware.png"),active_icon:require("./img/tabbar/tab_courseware_active.png")},
                    {name:"班级管理",path:"/classlist",icon:require("./img/tabbar/tab_classlist.png"),active_icon:require("./img/tabbar/tab_classlist_active.png")},
                    {name:"我",path:"/mine",icon:require("./img/tabbar/tab_my.png"),active_icon:require("./img/tabbar/tab_my_active.png")}
                ]
            }
        },
        created() {
        
        },
        methods: {
            
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #app_layout{
        width: 100vw;
        padding-bottom: 96px/$ppr;
        &.home_bj{
            background-color: #f5f6f7;
        }
        .nav_bar{
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 111px/$ppr;
            display: flex;
            align-items: center;
            background-color: #fff;
            border-top: 1px/$ppr solid #f5f5f5;
            .nav_item{
                width: 25%;
                text-align: center;
                &.active{
                    .nav_icon{
                        display: none;
                    }
                    .nav_active_icon{
                        display: block;
                    }
                    .nav_name{
                        color: #5e89ef;
                    }
                } 
                .nav_icon,.nav_active_icon{
                    width: 40px/$ppr;
                    display: block;
                    margin: 0 auto;
                }
                .nav_active_icon{
                    display: none;
                }
                .nav_name{
                    margin-top: 11px/$ppr;
                    font-size: 20px/$ppr;
                    line-height: 1;
                }
            }
        }
    }
</style>